<template>
<div class='container detail'>
    <div class='header'>
        <div class='title'>
            查看消息
        </div>
        <div class='information'>
            <div class='theme'>
                <span style='font-weight:600;margin-right:20px;'>主题:</span>
                <span style='font-weight:600;'>{{title}}</span>
            </div>
            <div class='recipients'>
                <span v-if="type == 'outbox'" style='margin-right:10px;'>收件人:</span>
                <span v-if="type == 'inbox'" style='margin-right:10px;'>发件人:</span>
                <span>{{userName}}</span>
            </div>
            <div class='date'>{{sendTime}}</div>
        </div>
    </div>
    <div class='section'>
        <div v-html='contents'>
        </div>
    </div>
    <div class='foot'>
        <div class='accessory' v-for='(item,index) in accessoryList' :key='index'>
            <img class='accessory_img' :src='item.attachment'/>
            <div class='accessory_label'>{{item.accessoryName}}</div>
        </div>
    </div>
</div>    
</template>

<script>
import ajax from '@/com/ajax'
import config from '@/com/config'

export default {
  data () {
    return {
      title: '',
      contents: '',
      sendTime: '',
      userName: '',
      type: '',
      accessoryList: []
    }
  },
  methods: {
    getQueryString (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var url = window.location.href.split('?')[1]
      if (url === undefined) {
        return false
      }
      var r = url.match(reg)
      if (r != null) { return decodeURI(r[2]) }
      return null
    },
    getContent (id) {
      let self = this
      ajax.get(`${config.khsHost}infoflow/message/${this.type}/detail/${id}`).then(function (res) {
        if (res && res.success) {
          self.title = res.body.title
          self.contents = res.body.contents
          self.sendTime = res.body.send
          self.userName = res.body.userName
          let list = res.body.accessoryList
          for (let i in list) {
            let obj = {}
            obj = list[i]
            self.$set(self.accessoryList, i, obj)
          }
          console.log(self.accessoryList)
        }
      })
    }
  },
  created () {
    let id = this.getQueryString('id')
    this.type = this.getQueryString('type')
    this.getContent(id)
  }
}
</script>

<style scoped>
.container.detail{
    padding:0px;
    width:100%;
    background-color: #ffffff;
}
.detail .header{
    padding-top:30px;
    padding-left:20px;
    width:100%;
}
.detail .title{
    font-size:24px;
    color:#ddd;
}
.detail .information{
    margin-top:20px;
    margin-left:10px;
    margin-bottom:20px;
}
.detail .information .theme{
    font-size:18px;
}
.detail .information .recipients{
    margin-top:5px;
    font-size:14px;
}
.detail .information .date{
   width:100%;
   text-align: right;
   font-size:14px;
   padding-right:50px;
}
.detail .section{
    padding-top:20px;
    padding-left:20px;
    min-height:200px;
    border-top:1px solid #ddd;
}
.detail .foot{
    display: flex;
    flex-wrap:wrap;
    width:100%;
    min-height:150px;
    padding-top:10px;
    padding-left:10px;
    border-top:1px solid #ddd;
}
.accessory_img{
    width:120px;
    height:120px;
}
.accessory{
    width:120px;
    margin-right:10px;
    margin-bottom:10px;
}
.accessory_label{
    width:120px;
    background-color:#eeeeee;
    line-height:30px;
    margin-top:-30px;
    position: absolute;
    padding-left:10px;
    display: none;
}
.accessory:hover .accessory_label{
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/notice/detail.vue?0dc31b78